import { render } from "./TourItinerary.vue?vue&type=template&id=04c21046"
import script from "./TourItinerary.vue?vue&type=script&lang=js"
export * from "./TourItinerary.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__